import { render, staticRenderFns } from "./WorkflowPrepServerTable.vue?vue&type=template&id=77a1d7b4"
import script from "./WorkflowPrepServerTable.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports